export const tutorialColors = {
  bg: 'darkBlue.main',
  buttonColor: 'digiGreen.main',
  color: 'white',
}
